{
  "profile": "Profile",
  "nbOfUsers": "Number of users",
  "validation": {
    "name": "Profile name is required",
    "maxLength": "Name must be 50 characters max"
  },
  "roles": "Roles",
  "name": "Profile name",
  "empty": "No roles available",
  "confirmDelete": {
    "title": "Profile removal",
    "description": "The selected profile \"{userProfileName}\" will be removed"
  },
  "cannotDelete": {
    "title": "Profile removal cannot be done",
    "description": "The selected profile \"{userProfileName}\" is associated with {usersCount} users"
  },
  "button": {
    "delete": "Delete profile"
  },
  "identity": "Identity",
  "new": "New profile",
  "label": {
    "operator": "Operator",
    "administrator": "Administrator"
  }
}
